import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["content", "summary", "turboStream"]
  declare readonly contentTarget: HTMLElement
  declare readonly summaryTarget: HTMLElement

  static values = {
    open: { type: Boolean, default: false }
  }
  declare openValue: boolean

  turboStreamTargetConnected(): void {
    this.open()
  }

  openValueChanged(): void {
    this.contentTarget.style.marginTop = this.openValue
      ? `-${this.summaryTarget.scrollHeight}px`
      : "0px"

    this.dispatch(this.openValue ? "open" : "close", { detail: { drawer: this } })
  }

  afterTransition(callback: () => void): void {
    const onTransitionEnd = (e: TransitionEvent): void => {
      // There are several transitions firing on child elements in the drawer, but we only want to
      // run the callback once, when the `grid-template-rows` transition finishes (since that's the
      // one that affects layout).
      if (e.propertyName !== "grid-template-rows") {
        return
      }

      callback()
      this.contentTarget.removeEventListener("transitionend", onTransitionEnd)
    }

    this.contentTarget.addEventListener("transitionend", onTransitionEnd)
  }

  close(): void {
    this.openValue = false
  }

  open(): void {
    this.openValue = true
  }
}
